import { motion } from "framer-motion";
import { Lightbulb, ChefHat, Martini, Flower2, Armchair, Music, Lamp, PartyPopper, Users } from "lucide-react";
import { useMobilI18n, MOBIL_SERVICE_KEYS } from "@/lib/mobilI18n";

const ICONS = {
  concept: Lightbulb, catering: ChefHat, bar: Martini, decor: Flower2, furniture: Armchair,
  sound: Music, lighting: Lamp, entertainment: PartyPopper, staff: Users,
};

export default function MobilServices() {
  const { m } = useMobilI18n();
  return (
    <section id="serveis" data-testid="mobil-services" className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#2e5949] text-[#fdfcf9] overflow-hidden">
      <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-[#E2C9A0]/10 blur-3xl pointer-events-none" />
      <div className="relative max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-14">
          <div className="lg:col-span-6">
            <p className="uppercase tracking-[0.28em] text-xs text-[#E2C9A0] mb-4 font-medium">{m.services.eyebrow}</p>
            <h2 className="font-display text-4xl md:text-5xl tracking-[-0.02em] leading-[1.05]">{m.services.title}</h2>
          </div>
          <p className="lg:col-span-5 lg:col-start-8 self-end text-[#fdfcf9]/80 leading-relaxed">{m.services.desc}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {MOBIL_SERVICE_KEYS.map((key, i) => {
            const Icon = ICONS[key];
            const item = m.services.items[key];
            return (
              <motion.div
                key={key}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, delay: (i % 3) * 0.08 }}
                data-testid={`mobil-service-${key}`}
                className="group rounded-2xl border border-[#fdfcf9]/12 bg-[#fdfcf9]/[0.04] backdrop-blur-sm p-7 hover:bg-[#fdfcf9]/[0.08] hover:-translate-y-1 hover:border-[#E2C9A0]/40 transition-[transform,background-color,border-color] duration-300"
              >
                <span className="w-11 h-11 rounded-full bg-[#E2C9A0]/15 text-[#E2C9A0] flex items-center justify-center group-hover:bg-[#E2C9A0] group-hover:text-[#2e5949] transition-colors">
                  <Icon size={20} />
                </span>
                <h3 className="mt-5 font-display text-2xl">{item.title}</h3>
                <p className="mt-2 text-sm text-[#fdfcf9]/75 leading-relaxed">{item.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
